import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entry-image entry-image--container" }
const _hoisted_2 = { class: "entry-image--placeholder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "placeholder", { src: _ctx.source }, undefined, true)
    ]),
    _createElementVNode("div", {
      class: "entry-image--image-container",
      style: _normalizeStyle(_ctx.style)
    }, [
      (_ctx.showZoom)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "entry-image--image-zoom-container",
            style: _normalizeStyle(_ctx.zoomStyle)
          }, null, 4))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}